import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/testingStructure/${ view }.vue`);
}


const Index = loadView( 'Index' );
const Edit = loadView( 'Edit' );
const Create = loadView( 'Create' );
const View = loadView( 'View' );


const testingStructureRoutes = [
    {
        path: 'structure',
        name: 'api.testing.structure.getList',
        component: Index,
        meta: {
            middleware: permission,
        }
    },
    {
        path: 'structure/create',
        name: 'api.testing.structure.create',
        component: Create,
        meta: {
            middleware: permission,
        }
    },
    {
        path: 'structure/:id',
        name: 'api.testing.structure.get',
        component: View,
        meta: {
            middleware: permission,
        }
    },
    {
        path: 'structure/:id/edit',
        name: 'api.testing.structure.update',
        component: Edit,
        meta: {
            middleware: permission,
        }
    }
];

export default testingStructureRoutes;
